/*
 * Filename: config-output.model.ts
 * Description: config putput model.
 */

import { types, ModelInstanceTypeProps, ModelProperties, getSnapshot } from 'mobx-state-tree';
import { values } from 'mobx';
import { Utility } from '../../common/utility';
import { TemplateSFObjectStore } from './template-object.model';

const cqUtilityClass: Utility = new Utility();


export const OutputConfig = types.model({
    cqEsig: types.model({
        className: types.optional(types.string, ''),
        templateType:types.optional(types.string, 'cqEsig'),
        objectApiName: types.optional(types.string, ''),
        title: types.optional(types.string, ''),
        additionalFields: types.optional(types.array(types.string), []),
        inputRules: types.optional(types.frozen(), {}),
        lookupFilters: types.optional(types.frozen(), {}),
        dynamicSource: types.optional(types.frozen(), {}),
        picklistValueSource: types.optional(types.frozen(), {}),
        formulaFields: types.optional(types.string, ''),
        prefixName: types.optional(types.string, ''),
        esigAction: types.optional(types.string, ''),
        esigActionLabel: types.optional(types.string, ''),
        relatedField: types.optional(types.string, ''),
        parentField: types.optional(types.string, ''),
        layout: types.optional(types.frozen(), {}),
        ruleElements: types.optional(types.frozen(), {}),
        selectedObject: types.optional(types.string, ''),
        selectedLayout: types.optional(types.string, ''),
        selectedLayoutName:types.optional(types.string, ''),
        componentName: types.optional(types.string, ''),
        objectApiNameField: types.optional(types.frozen(), {}),
        componentType: types.optional(types.string, ''),
        esig: types.optional(types.boolean, true),
        componentNamespace: types.optional(types.string, ''),
        createNewQuickAction: types.optional(types.boolean, true),
        uiType: types.optional(types.frozen(), ''),
    }),
    cqEsigAction: types.model({
        className: types.optional(types.string, ''),
        templateType:types.optional(types.string, 'cqEsigAction'),
        additionalFields: types.optional(types.array(types.string), []),
        taskType: types.optional(types.string, ''),
        componentName: types.optional(types.string, ''),  //cqTemplate,
        dynamicSource: types.optional(types.frozen(), {}),
        flowName: types.optional(types.string, ''),
        flowVariables: types.optional(types.string, ''),
        formulaFields: types.optional(types.string, ''),
        recordType: types.optional(types.string, ''),
        hideCQAction: types.optional(types.string, ''),
        defaultValues: types.optional(types.string, ''),
        inputRules: types.optional(types.frozen(), {}),
        layout: types.optional(types.frozen(), {}),
        lookupFilters: types.optional(types.frozen(), {}),
        objectApiName: types.optional(types.string, ''),
        parentField: types.optional(types.string, ''),
        picklistValueSource: types.optional(types.frozen(), {}),
        prefixName: types.optional(types.string, ''),
        relatedField: types.optional(types.string, ''),
        ruleElements: types.optional(types.frozen(), {}),
        selectedObject: types.optional(types.string, ''),
        selectedLayout: types.optional(types.string, ''),
        selectedLayoutName:types.optional(types.string, ''),
        parentObjectApi: types.optional(types.string, ''),
        pageTitle: types.optional(types.string, ''),
        showFile: types.optional(types.boolean, false),
        uiType: types.optional(types.frozen(), '')
    }),

    // Perform CQ Actions

    cqForm: types.model({
        className: types.optional(types.string, ''),
        templateType:types.optional(types.string, 'cqForm'),
        additionalFields: types.optional(types.array(types.string), []),
        dynamicSource: types.optional(types.frozen(), {}),
        formulaFields: types.optional(types.frozen(), {}),
        suffixName: types.optional(types.string, ''),
        hideSaveAndNew:types.optional(types.boolean, false),
        showFile:types.optional(types.boolean, false),
        prefixName: types.optional(types.string, ''),
        iconName: types.optional(types.string, ''),
        layout: types.optional(types.frozen(), {}),
        inputRules: types.optional(types.frozen(), {}),
        lookupFilters: types.optional(types.frozen(), {}),
        picklistValueSource: types.optional(types.frozen(), {}),
        uiType: types.optional(types.frozen(), ''), //'' or {}
        actionOverride: types.optional(types.string, ''),
        fileUploader: types.optional(types.string, ''),
        parentObjectApi: types.optional(types.string, ''),
        ruleElements: types.optional(types.frozen(), {}),
        selectedObject: types.optional(types.string, ''),
        selectedLayout: types.optional(types.string, ''),
        selectedLayoutName:types.optional(types.string, ''),
        componentName: types.optional(types.string, ''),
        componentNamespace: types.optional(types.string, ''),
        recordTypeDeveloperName: types.optional(types.string, ''),
        pageTitle: types.optional(types.string, ''),
        customTitle: types.optional(types.string, ''),
        supportsFlowScreen: types.optional(types.boolean,false),
    }),
    // CQ Record Create/Edit Form

    // Grid with Custom Actions
    cqGridGenerator: types.model({
        rowActions: types.optional(types.array(types.frozen()), []),
        templateType:types.optional(types.string, 'cqGridGenerator'),
        rowFormRules: types.optional(types.frozen(), {}),
        headerActions: types.optional(types.array(types.frozen()), []),
        headerFormRules: types.optional(types.frozen(), {}),
        parentFields: types.optional(types.array(types.string), ['Id' , 'Name']),
        iconName: types.optional(types.string, ''),
        prefix: types.optional(types.string, ''),
        componentName: types.optional(types.string, ''),
        fields: types.optional(types.array(types.frozen()), []),
        sortOrder: types.optional(types.string, ''),
        orderBy: types.optional(types.string, ''),
        relationalField: types.optional(types.string, ''),
        andClause: types.optional(types.string, ''),
        additionalFields: types.optional(types.array(types.string), []),
        showNewAsPopup: types.optional(types.string, ''),
        limitToRecordType: types.optional(types.string, ''),
        ShowNewAsPopup: types.optional(types.boolean, true),
        objectApiName: types.optional(types.string, ''),
        parentObjectApiName: types.optional(types.string, ''),
        ruleElements: types.optional(types.frozen(), {}),
        inputRules: types.optional(types.frozen(), {}),
        selectedObject: types.optional(types.string, ''),
        selectedLayout: types.optional(types.string, ''),
        customTitle: types.optional(types.string, ''),
        prefixName: types.optional(types.string, ''),
        suffixName: types.optional(types.string, ''),
        defaultFieldValue: types.optional(types.frozen(), {}),
    }),
    cqNBA: types.model({
        quickActions: types.optional(types.array(types.frozen()), []),
        templateType:types.optional(types.string, 'cqNBA'),
        ruleElements: types.optional(types.frozen(), {}),
        selectedObject: types.optional(types.string, ''),
        componentName: types.optional(types.string, ''),
        objectApiName: types.optional(types.string, ''),
        suffixName: types.optional(types.string, ''),
        prefixName: types.optional(types.string, ''),
        className: types.optional(types.string, ''),
        inputRules: types.optional(types.frozen(), {}),
        additionalFields: types.optional(types.array(types.string), []),
        layout: types.optional(types.frozen(), {}),
        namespacePrefix : types.optional(types.string, ''),
    }),
    // cqNBA - Next Best Action
    cqTemplate: types.model({
        templateContent: types.optional(types.string, ''),
        templateType:types.optional(types.string, 'cqTemplate'),
        componentName: types.optional(types.string, ''),
        ruleElements: types.optional(types.frozen(), {}),
        selectedObject: types.optional(types.string, ''),
        selectedLayout: types.optional(types.string, ''),
    })
    // cqTemplate 
}).actions((self: any, initialState: any = {}) => ({
    afterCreate: () => {
        initialState = getSnapshot(self);
    },
    reset() {
        Object.keys(self).forEach((itemKey: string) => {
            self[itemKey] = initialState[itemKey];
        });
    },
    resetFromKey(selectedTemplate: string, keys: string[]){
        const templateName = cqUtilityClass.getStoreName(selectedTemplate);
        keys.forEach((key: string) => {
            self[templateName][key] = initialState[templateName][key];
        })
    },
    updateTemplatePropertyValue(selectedTemplate: string, key: string, value: any) {
        const templateName = cqUtilityClass.getStoreName(selectedTemplate);
        self[templateName][key] = value;
    },
    setTemplateObject(selectedTemplate: string, templateObject: any) {
        const templateName = cqUtilityClass.getStoreName(selectedTemplate);
        self[templateName] = templateObject;
    },
    setSelectedObject(selectedTemplate: string, objectName: string) {
        const templateName = cqUtilityClass.getStoreName(selectedTemplate);
        self[templateName].selectedObject = objectName;
        if(templateName !== 'cqEsig100'){
            self[templateName].objectApiName = objectName;
        }
    },
    setSelectedLayout(selectedTemplate: string, layoutId: string) {
        const templateName = cqUtilityClass.getStoreName(selectedTemplate);
        self[templateName].selectedLayout = layoutId;
    },
    setLayoutMetadata(selectedTemplate: string, key: string, layoutMetadata: any) {
        const templateName = cqUtilityClass.getStoreName(selectedTemplate);
        self[templateName].layout = layoutMetadata;

    },
    setQuickActions(selectedTemplate: string, quickActions: any) {
        const templateName = cqUtilityClass.getStoreName(selectedTemplate);
        quickActions.map((element:any)=>{
            for(const [keys, keyValues] of Object.entries(TemplateSFObjectStore.quickActions)) {
                if(element["fullName"] === keyValues.DeveloperName){
                    let updatedQuickActionKey:string = `${keyValues.NamespacePrefix}__${element["fullName"]}`;
                    if(keyValues.NamespacePrefix === ''){
                        updatedQuickActionKey = `${element["fullName"]}`;
                    }
                    element["fullName"] = updatedQuickActionKey;
                    element['NamespacePrefix'] = keyValues.NamespacePrefix;
                }
            }
        })
        self[templateName].quickActions = quickActions;

    },
    getQuickActions(selectedTemplate: string) {
        const templateName = cqUtilityClass.getStoreName(selectedTemplate);
        return self[templateName].quickActions;
    },
    getSelectedObject(selectedTemplate: string) {
        const templateName = cqUtilityClass.getStoreName(selectedTemplate);
        return self[templateName].selectedObject;
    },
    getSelectedLayout(selectedTemplate: string) {
        const templateName = cqUtilityClass.getStoreName(selectedTemplate);
        return self[templateName].selectedLayout;
    },
    setInputRules(selectedTemplate: string, ruleJsonObject: any) {
        const templateName = cqUtilityClass.getStoreName(selectedTemplate);
        self[templateName].inputRules = ruleJsonObject;
    },
    setDynamicSource(selectedTemplate: string, ruleJsonObject: any) {
        const templateName = cqUtilityClass.getStoreName(selectedTemplate);
        self[templateName].dynamicSource = ruleJsonObject;
    },
    setRuleElements(selectedTemplate: string, ruleElementObject: any) {
        const templateName = cqUtilityClass.getStoreName(selectedTemplate);
        self[templateName].ruleElements = ruleElementObject;
    },
    deleteRule(selectedTemplate: string, fieldName: string, ruleType: string, ruleObjectType: string) {
        const templateName = cqUtilityClass.getStoreName(selectedTemplate);
        let templateObj = { ...self[templateName] };
        if (ruleObjectType === 'lookupFilters') {
            let ruleObject = { ...templateObj[ruleObjectType][fieldName] };
            if (ruleType === 'fields') {
                const ruleKeys = Object.keys(ruleObject);
                if (ruleKeys.length > 1) {
                    ruleObject.fields = [];
                    let fieldObj = { ...templateObj[ruleObjectType] };
                    fieldObj[fieldName] = { ...ruleObject };
                    templateObj[ruleObjectType] = { ...fieldObj };
                    self[templateName] = templateObj;
                } else {
                    let lookupFilterObj = { ...templateObj[ruleObjectType] };
                    delete lookupFilterObj[fieldName];
                    templateObj[ruleObjectType] = lookupFilterObj;
                    self[templateName] = templateObj;
                }
            } else {
                if (ruleObject.fields.length > 0) {
                    delete ruleObject.filters;
                    delete ruleObject.logic;
                    templateObj[ruleObjectType][fieldName] = ruleObject;
                    self[templateName] = templateObj;
                } else {
                    let ruleObj = { ...templateObj[ruleObjectType] }
                    delete ruleObj[fieldName];
                    templateObj[ruleObjectType] = ruleObj;
                    self[templateName] = templateObj;
                }
            }
        } else {
            let ruleObject = cqUtilityClass.createObjectDeepCopy(templateObj[ruleObjectType]);
            if (ruleType === 'onLoad-invoke' || ruleType === 'onLoad-setValues' || ruleType === 'onLoad-transfer') {
                if (ruleObject.hasOwnProperty('onLoad') && Object.keys(ruleObject.onLoad).length > 1) {
                    if (ruleType.includes('invoke')) {
                        delete ruleObject['onLoad']['invoke'];
                        templateObj[ruleObjectType] = ruleObject;
                        self[templateName] = templateObj;
                    } else if (ruleType.includes('setValues')) {
                        delete ruleObject['onLoad']['setValues'];
                        templateObj[ruleObjectType] = ruleObject;
                        self[templateName] = templateObj;
                    }
                    else if (ruleType.includes('transfer')) {
                        delete ruleObject['onLoad']['transfer'];
                        templateObj[ruleObjectType] = ruleObject;
                        self[templateName] = templateObj;
                    }
                } else {
                    delete ruleObject['onLoad'];
                    templateObj[ruleObjectType] = ruleObject;
                    self[templateName] = templateObj;
                }
            } else if (ruleType === 'onInit-invoke') {
                delete ruleObject['onInit'];
                templateObj[ruleObjectType] = ruleObject;
                self[templateName] = templateObj;
            } else if (ruleType === 'afterSave-redirectTo') {
                delete ruleObject['afterSave'];
                templateObj[ruleObjectType] = ruleObject;
                self[templateName] = templateObj;
            }
            else {
                const fieldRuleObjectKeys = Object.keys(ruleObject[fieldName]);
                if (fieldRuleObjectKeys.includes(ruleType) && fieldRuleObjectKeys.length > 1) {
                    let fieldObj = { ...ruleObject[fieldName] };
                    delete fieldObj[ruleType];
                    ruleObject[fieldName] = { ...fieldObj };
                    templateObj[ruleObjectType] = ruleObject;
                    self[templateName] = templateObj;
                } else {
                    let ruleObj = { ...templateObj[ruleObjectType] };
                    delete ruleObj[fieldName];
                    templateObj[ruleObjectType] = ruleObj;
                    self[templateName] = templateObj;
                }
            }
        }
    },
    setLookupFilters(selectedTemplate: string, ruleJsonObject: any) {
        const templateName = cqUtilityClass.getStoreName(selectedTemplate);
        self[templateName].lookupFilters = ruleJsonObject;
    },
    setPicklistValueSource(selectedTemplate: string, picklistValueSource: any) {
        const templateName = cqUtilityClass.getStoreName(selectedTemplate);
        self[templateName].picklistValueSource = picklistValueSource;

    },
    setuiType(selectedTemplate: string, uiTypeDetail: any) {
        const templateName = cqUtilityClass.getStoreName(selectedTemplate);
        self[templateName].uiType = uiTypeDetail;

    },
    setFormulaField(selectedTemplate: string, objectName: string, formulaRuleObject: any) {
        const templateName = cqUtilityClass.getStoreName(selectedTemplate);
        if (Object.keys(self[templateName].formulaFields).length === 0) {
            self[templateName].formulaFields = { [objectName]: formulaRuleObject };
        } else {
            if (self[templateName].formulaFields.hasOwnProperty(objectName)) {
                const existingRuleObject = { ...self[templateName].formulaFields };
                existingRuleObject[objectName] = { ...formulaRuleObject };
                self[templateName].formulaFields = existingRuleObject;
            }
            else {
                const fieldRuleObject = { ...self[templateName].formulaFields, [objectName]: formulaRuleObject };
                self[templateName].formulaFields = fieldRuleObject;
            }
        }

    },
    setlookupFilters(selectedTemplate: string, objectName: string, lookupFilterRuleObject: any) {
        const templateName = cqUtilityClass.getStoreName(selectedTemplate);
        if (Object.keys(self[templateName].lookupFilters).length === 0) {
            self[templateName].lookupFilters = { [objectName]: lookupFilterRuleObject };
        } else {
            if (self[templateName].lookupFilters.hasOwnProperty(objectName)) {
                const existingRuleObject = { ...self[templateName].lookupFilters };
                existingRuleObject[objectName] = { ...lookupFilterRuleObject };
                self[templateName].lookupFilters = existingRuleObject;
            }
            else {
                const fieldRuleObject = { ...self[templateName].lookupFilters, [objectName]: lookupFilterRuleObject };
                self[templateName].lookupFilters = fieldRuleObject;
            }
        }

    },
    setAdditionalFields(selectedTemplate: string, fields: string[]) {
        const templateName = cqUtilityClass.getStoreName(selectedTemplate);
        const additionalFields = [...self[templateName].additionalFields];
        fields.forEach((fieldAPIName: string) => {
            const isFieldAPINameExist = additionalFields.some((additonalFieldAPIName: string) => additonalFieldAPIName === fieldAPIName);
            if (!isFieldAPINameExist) {
                additionalFields.push(fieldAPIName);
            }
        });
        self[templateName].additionalFields = additionalFields;
    }
})).views((self: ModelInstanceTypeProps<ModelProperties>) => ({
    get validOutputConfigJson() {
        return self.values;
    },
    isPublishValid(selectedTemplate: string) {
        const templateName = cqUtilityClass.getStoreName(selectedTemplate);
        if (self[templateName].templateType === 'cqForm') {
            return (self[templateName].selectedObject !== '' && self[templateName].selectedLayout !== '' && self[templateName].className !== '');
        } 
        else if (self[templateName].templateType === 'cqGridGenerator') {
            return (self[templateName].objectApiName !== '' && self[templateName].parentObjectApiName !== '' && 
            self[templateName].fields.length > 0 && self[templateName].componentName !== '' && 
            self[templateName].parentFields.length > 0);
        }
        else if (selectedTemplate === 'cqEsig' || self[templateName].templateType === 'cqEsigAction'){
            return (self[templateName].selectedObject !== '');
        }
        else if (selectedTemplate === 'cqEsig100' || selectedTemplate === 'cqNBA'){
            return true;
        }
        else {
            return false;
        }
    },
    getDynamicSource(selectedTemplate: string, objectName: string) {
        const templateName = cqUtilityClass.getStoreName(selectedTemplate);
        let dynamicSourceObject = {};
        const dynamicRuleObject = { ...self[templateName].dynamicSource };
        if (dynamicRuleObject.hasOwnProperty(objectName)) {
            dynamicSourceObject = { ...dynamicRuleObject[objectName] };
        }
        return dynamicSourceObject;
    },
    getTemplateLayoutMetadata(selectedTemplate: string) {
        const templateName = cqUtilityClass.getStoreName(selectedTemplate);
        return self[templateName].layout;
    },
    getTemplateInputRules(selectedTemplate: string) {
        const templateName = cqUtilityClass.getStoreName(selectedTemplate);
        return self[templateName].inputRules;
    },
    getSelectedLayoutFields(selectedTemplate: string) {
        const templateName = cqUtilityClass.getStoreName(selectedTemplate);
        if (self[templateName].layout && self[templateName].layout.metadata && self[templateName].layout.metadata.fields) {
            return Object.keys(self[templateName].layout.metadata.fields).map((fieldKey: string) => {
                return {
                    fieldFullName: self[templateName].layout.metadata.fields[fieldKey].fullName,
                    fieldLabel: self[templateName].layout.metadata.fields[fieldKey].label,
                    fieldType: self[templateName].layout.metadata.fields[fieldKey].type || 'text',
                    referenceTo: self[templateName].layout.metadata.fields[fieldKey].referenceTo,
                    relationshipName: self[templateName].layout.metadata.fields[fieldKey].relationshipName,
                };
            }).sort((a: any, b: any) => { return a.fieldLabel > b.fieldLabel ? 1 : (a.fieldLabel === b.fieldLabel ? 0 : -1); });
        }
        return [];
    },
    getTemplatePickuplistValueSource(selectedTemplate: string) {
        const templateName = cqUtilityClass.getStoreName(selectedTemplate);
        return self[templateName].picklistValueSource;
    },
    getTemplateuiType(selectedTemplate: string) {
        const templateName = cqUtilityClass.getStoreName(selectedTemplate);
        return self[templateName].uiType;
    },
    // Grid template @views methods
    getHeaderActions(selectedTemplate: string) {
        const templateName = cqUtilityClass.getStoreName(selectedTemplate);
        return values(self[templateName].headerActions);
    },
    getStoreKeyData(selectedTemplate: string, key: string) {
        const templateName = cqUtilityClass.getStoreName(selectedTemplate);
        return cqUtilityClass.createObjectDeepCopy(self[templateName][key]);
    },
    getStoreData(selectedTemplate: string) {
        const templateName = cqUtilityClass.getStoreName(selectedTemplate);
        return cqUtilityClass.createObjectDeepCopy(self[templateName]);
    }
}));


export type IOutputConfigStore = typeof OutputConfig.Type;
